import React, { useEffect, useState } from "react";
import "./style.scss";
import Table from "../../Table";
import goldMedal from "../../../assets/icons/Gold_medal.svg";
import silverMedal from "../../../assets/icons/Silver_medal.svg";
import bronzeMedal from "../../../assets/icons/Bronze_medal.svg";
import rankMedal from "../../../assets/icons/rank_logo.svg";
import { useSelector } from "react-redux";
import { getLeaderboard } from "../../../utils/apis/competition";
import { useLocation, useParams } from "react-router-dom";
import moment from "moment";
import { formatDateInTimeZone, FormatUSD } from "../../../utils/helpers/string";
const CompetitonDetail = () => {
  const { idToken } = useSelector((state) => state.auth);
  const [leaderboard, setLeadeboard] = useState([]);
  const { id } = useParams();
  const { state } = useLocation();

  const getLeaderboards = async () => {
    const res = await getLeaderboard(idToken, Number(id));
    setLeadeboard(res?.data || []);
  };
  useEffect(() => {
    getLeaderboards();
  }, []);

  const columns = [
    {
      Header: "#",
      accessor: "position",
      Cell: ({ row, value }) => {
        return (
          <>
            <div className="rank_Wrapper">
              <img
                src={`${row.index + 1 === 1
                  ? goldMedal
                  : row.index + 1 === 2
                    ? silverMedal
                    : row.index + 1 === 3
                      ? bronzeMedal
                      : rankMedal
                  }`}
                alt="trophy icon"
              />{" "}
            </div>
          </>
        );
      },
    },
    { Header: "Full Name", accessor: "full_name" },
    { Header: "Account Number", accessor: "account_name" },
    {
      Header: "Profit",
      accessor: "total_pnl",
      Cell: ({ value }) => (
        <span className={value >= 0 ? "positive_value" : "negative_value"}>
          {FormatUSD(value)}
        </span>
      ),
    },
    { Header: "Trades", accessor: "trade_count" },
    {
      Header: "Win Rate",
      accessor: "win_rate",
      Cell: ({ value }) => `${Number(value).toFixed(2)}%`,
    },
    {
      Header: "Profit Factor",
      accessor: "profit_factor",
      Cell: ({ value }) => Number(value).toFixed(2),
    },
    {
      Header: "RRR",
      accessor: "rrr",
      Cell: ({ value }) => Number(value).toFixed(2),
    },
  ];
  const [timeRemaining, setTimeRemaining] = useState(
    state?.end_Date
      ? moment.utc(state?.end_Date).diff(moment.utc(), "milliseconds")
      : 0
  );

  useEffect(() => {
    const calculateTimeRemaining = () =>
      state?.end_Date
        ? moment.utc(state?.end_Date).diff(moment.utc(), "milliseconds")
        : 0;

    const timerInterval = setInterval(() => {
      const remaining = calculateTimeRemaining();
      setTimeRemaining(remaining > 0 ? remaining : 0);
    }, 1000);

    return () => clearInterval(timerInterval);
  }, [state?.end_Date]);

  const duration = moment.duration(timeRemaining);
  const days = String(Math.floor(duration.asDays())).padStart(2, "0");
  const hours = String(duration.hours()).padStart(2, "0");
  const minutes = String(duration.minutes()).padStart(2, "0");
  const seconds = String(duration.seconds()).padStart(2, "0");
  return (
    <>
      <div className="competitonDetail_container">
        <div className="competitionDetail_wrapper">
          <div className="topSection">
            <div className="competitionDetail_status">
              <h2>{state?.name || "Competition"}</h2>
              <p>{state?.challenge ? `Challenge #${state?.challenge}` : ""}</p>
              <div
                className={`comp_status ${state?.status === "Participated" || state?.status === "End"
                  ? "red_status"
                  : state?.status === "Upcoming"
                    ? "yellow_status"
                    : "green_status"
                  }`}
              >
                <p>{state?.status || "N/A"}</p>
              </div>
            </div>
            <div className="competitionDetail_info">
              <div className="compDetail_info_box">
                <p className="compDetail_header">End Date</p>
                <p className="info">{formatDateInTimeZone(state?.end_Date)}</p>
              </div>
              <div className="compDetail_info_box">
                <p className="compDetail_header">Ends In</p>
                <p className="info">{`${days}d : ${hours}h : ${minutes}m : ${seconds}s left`}</p>
              </div>
              <div className="compDetail_info_box">
                <p className="compDetail_header">Prizes</p>
                <p className="info">1st: {state?.first_prize}</p>
                <p className="info">2nd: {state?.second_prize}</p>
                <p className="info">3rd: {state?.third_prize}</p>
              </div>
              <div className="compDetail_info_box">
                <p className="compDetail_header">Contestant</p>
                <p className="info">
                  {state?.participated_contestants || 0} /{" "}
                  {state?.total_contestants || 0}
                </p>
              </div>
            </div>
          </div>
          <div className="leaderboardTable">
            <div className="leaderboardTable_container">
              <div className="leaderboardTable_wrapper">
                <Table columns={columns} data={leaderboard || []} variant={2} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompetitonDetail;
